import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { productViewLabels } from '../../data/images';
import type { ProductView } from '../../data/images';
import { ProductAssetSlot } from './ProductAssetSlot';
const VIEWS: ProductView[] = ['front', 'lit', 'side', 'rear', 'mount', 'packaging'];
export function ProductGallery() {
  const [active, setActive] = useState<ProductView>('front');
  return <div data-id="element-483" data-mp="1yfzkabepf1uu">
      <AnimatePresence mode="wait" data-id="element-484" data-mp="1yg9cm5n81l3p">
        <motion.div key={active} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18
      }} data-id="element-485" data-mp="23gdu9yzv8lvi">
          <ProductAssetSlot view={active} tone="studio" className="aspect-square w-full" data-id="element-486" data-mp="1ti7t5jlvvjrp" />
        </motion.div>
      </AnimatePresence>
      <div className="mt-4 grid grid-cols-6 gap-2" role="tablist" aria-label="Product views" data-id="element-487" data-mp="3jvymesxjzidg">
        {VIEWS.map(v => <button key={v} type="button" role="tab" aria-selected={active === v} aria-label={productViewLabels[v]} onClick={() => setActive(v)} className={`overflow-hidden rounded-lg border-2 transition-[border-color] duration-150 ${active === v ? 'border-marine' : 'border-transparent hover:border-titanium/30'}`} data-id="element-488" data-mp="3nvpj1d9rgspw">
            <ProductAssetSlot view={v} compact className="aspect-square w-full !rounded-md !border-0" data-id="element-489" data-mp="nv9hss0ojxgs" />
          </button>)}
      </div>
      <p className="mt-3 text-sm text-titanium" data-id="element-490" data-mp="ixq35r02liob">{productViewLabels[active]}</p>
    </div>;
}